
import { Vue, Options } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { openToast } from "toast-ts";
import { PrizeModel } from "../../model/lottery/LotteryModel";
@Options({
  props: {
    toastShow: Boolean
  },
  emits: {
    isshowaction: () => {
      return true;
    },
    reloadData: () => {
      return true;
    }
  }
})
export default class RedeemPrizesToast extends Vue {
  private dataModel: PrizeModel | null = null;
  mounted() {
    this.getPrizeData();
  }
  getPrizeData() {
    Http.get<PrizeModel>(Urls.lottery_luckyValueAward).then(
      (res: PrizeModel) => {
        this.dataModel = res;
      },
      (err: ResponseData) => {
        console.log("RedeemPrizesToast:", err.message);
        // openToast(err.message);
      }
    );
  }

  /// 确定的背景颜色
  isDown = false;
  name = "";
  phone = "";
  address = "";
  inputName() {
    this.isDownAction();
  }
  inputPhone() {
    this.isDownAction();
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputAdd(event: any) {
    event;
    this.isDownAction();
  }
  isDownAction() {
    if (
      this.name.length > 0 &&
      this.phone.length == 11 &&
      this.address.length > 0
    ) {
      this.isDown = true;
    } else {
      this.isDown = false;
    }
  }
  redeemPrizes() {
    if (!this.isDown) return;
    const data = {
      type: 2,
      contactPhone: this.phone,
      contactAddr: this.address,
      contactPerson: this.name
    };
    Http.post<string>(Urls.lottery_order, data).then(
      () => {
        openToast("兑换成功");
        // eslint-disable-next-line vue/custom-event-name-casing
        this.$emit("reloadData");
      },
      () => {
        openToast("兑换失败，查看具体原因，请联系客服。");
      }
    );
  }
}
